module.exports = __webpack_public_path__ + "img/TOAD.99dfa63b.svg";